import { ToastMessage } from '@/core/models/toast.model';
import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly MAX_VISIBLE = 4;
  private readonly toastsSignal = signal<ToastMessage[]>([]);

  readonly visibleToasts = computed(() => this.toastsSignal().slice(0, this.MAX_VISIBLE));
  readonly toastQueue = computed(() => this.toastsSignal().slice(this.MAX_VISIBLE));

  show(toast: Omit<ToastMessage, 'id'>) {
  const newToast: ToastMessage = {
    id: crypto.randomUUID(),
    ...toast
  };

  this.toastsSignal.update(current => [...current, newToast]);
  
  const duration = this.getDurationForToastType(toast.type, toast.duration);
  
  setTimeout(() => {
    this.dismiss(newToast.id);
  }, duration);
  }

  private getDurationForToastType(type: string, customDuration?: number): number {
    if (customDuration) {
      return customDuration;
    }

    switch (type) {
      case 'success':
        return 4000;
      case 'error':
        return 6000;
      case 'warning':
        return 5000;
      case 'info':
        return 4000;
      default:
        return 4000;
    }
  }

  dismiss(id: string) {
    this.toastsSignal.update(current => current.filter(t => t.id !== id));
    
  }
}
